import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { URL_PATHS } from "../../src/routes";
import { UserStatus } from "../../src/generated/lib-domain/user";
import { AppState } from "../../src/store";
import InstallAppPage from "../pages/InstallApp";
import { useOnceCall } from "../custom-hooks/once-call";
import { paymentActions } from "../store/payment";

const InstallAppContainer = (): JSX.Element => {
    const dispatch = useDispatch();
    const myUser = useSelector((state: AppState) => state.myData.user);
    useOnceCall(() => {
        dispatch(paymentActions.selectedPaymentSet(null));
    });
    if (myUser?.status === UserStatus.Active) {
        return <Redirect to={URL_PATHS.myPage()} />;
    }
    return <InstallAppPage />;
};

export default InstallAppContainer;
